import { useQuery } from '@tanstack/react-query';
import Api from '../helpers/Api';

type UseQrCodeParams = {
  language: string;
  locationId: string;
};

const makeUseQrCodeKey = ({ language, locationId }: UseQrCodeParams) => [
  `language:${language}`,
  `locationId:${locationId}`,
];

export function useQrCode({ language, locationId }: UseQrCodeParams) {
  const fetchQrCode = async () => {
    return Api.qrCode().generate({
      locationId,
      language,
    });
  };

  return useQuery({
    enabled: !!locationId && !!language,
    staleTime: 1000 * 60 * 60, // 60 minutes
    queryKey: makeUseQrCodeKey({ locationId, language }),
    queryFn: fetchQrCode,
  });
}
